export class MagnetoScenePlayNotification {
    public Expiration: Date;
    public IsForceAllScenes: boolean;
    public IsOn: boolean;
    public IsOnWithDuration: boolean;
    public LocationId: number;
    public SceneId: number;
    public ThemeId: number;
    public SceneNumber: number;
    public ThemeNumber: number;
    public TypeCode: number;
    public WasSuccess: boolean;

    constructor(json: object = null) {
        if (json) {
            Object.assign(this, json);

            this.Expiration = new Date(json['Expiration']);
        }
    }
}
